import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Text,
  Modal,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  VStack,
} from '@chakra-ui/react';

import { useGetDemoAnswers } from '../../modules/app/hooks/useDemo';
import { DemoField } from '../../modules/app/hooks/api/types';
import { AuthContext } from '../../context/AuthProvider';
import { axiosWrapper } from '../../hooks/axios';
import DemoAskForm from '../../modules/auth/components/DemoAskForm';

interface DemoAskModalProps {
  setIsOpen: (v: boolean) => void;
}

const DemoAskModal: React.FC<DemoAskModalProps> = (
  props: DemoAskModalProps,
) => {
  const { setIsOpen } = props;
  const user = useContext(AuthContext);

  const [hugeState, setHugeState] = useState<{
    [key: string]: { [key: string]: DemoField };
  }>({});
  const [demoAnswers] = useGetDemoAnswers();

  useEffect(() => {
    if (user && user.demos_to_ask && user.demos_to_ask.length) {
      let a: {
        [key: string]: {
          [key: string]: {
            key: string;
            name: string;
            type: string;
            value: any;
            default: any;
            previousValue: any;
          };
        };
      } = {};
      user.demos_to_ask.forEach((demo) => {
        a[demo.demo] = {};
        demo.ask.forEach((field) => {
          let answer: any = { value: null };
          if (demoAnswers && demoAnswers[`${demo.demo}-${field.key}`]) {
            answer.value = demoAnswers[`${demo.demo}-${field.key}`]!.value;
          }
          // @ts-ignore
          a[demo.demo][field.key] = {
            ...field,
            previousValue: answer.value,
            value: answer.value || field.default,
          };
        });
      });
      setHugeState(a);
    }
  }, [user, demoAnswers]);

  const onSubmit = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    const URL = '/api/v1/records/demo/answer/';
    type UpdateResponse = { error: string | undefined; ok: boolean };

    let data: any = {};

    user?.demos_to_ask?.forEach((demo) => {
      data[demo.demo] = {};
      data[demo.demo].data = [...demo.ask];
      data[demo.demo].data.forEach((field: any, index: number) => {
        data[demo.demo].data[index].value =
          // @ts-ignore
          hugeState[demo.demo][field.key].value;
      });
    });

    return axiosWrapper<UpdateResponse>(URL, 'patch', data)
      .then((res) => {
        if (res.data.ok) {
          setIsOpen(false);
        } else {
          alert(res.data.error);
        }
      })
      .catch((err) => console.error(err));
  };

  const onChange = (code: string, key: string) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      let nextState: any = { ...hugeState };
      nextState[code][key].value = e.target.value;
      setHugeState(nextState);
    };
  };

  return (
    <Modal isOpen={true} size="3xl" onClose={() => setIsOpen(false)}>
      <ModalOverlay />
      <ModalContent p={2}>
        <ModalHeader>
          <Text as="h3" textStyle="h3">
            Additional information for demo
          </Text>
        </ModalHeader>
        <ModalBody>
          <VStack spacing={0} gap={4}>
            {user?.demos_to_ask?.map((demo, index) => {
              demo.ask = demo.ask.map((field) => {
                let value =
                  // @ts-ignore
                  hugeState[demo.demo] && hugeState[demo.demo][field.key]
                    ? // @ts-ignore
                      hugeState[demo.demo][field.key]?.value
                    : undefined;

                return {
                  ...field,
                  value,
                };
              });

              return (
                <DemoAskForm
                  ask={demo.ask}
                  demo={demo.demo}
                  key={index}
                  onChange={onChange}
                  onSubmit={onSubmit}
                  isInModal={true}
                />
              );
            })}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ marginLeft: '8px' }}
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            style={{ marginLeft: '8px' }}
            type="submit"
            onClick={onSubmit}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DemoAskModal;
export { DemoAskModal };
